import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/category/xuexi-jiaoyu?q=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20warm%20gradient%20background%20with%20soft%20flowing%20shapes%20in%20coral%20and%20cream%20tones%2C%20modern%20minimalist%20digital%20art%2C%20smooth%20texture%2C%20elegant%20atmospheric%20composition%2C%20subtle%20light%20rays%2C%20professional%20design%20aesthetic&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="狠狠撸背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/20"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-6 inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full">
          <i className="ri-sparkling-2-line text-primary-300 text-sm"></i>
          <span className="text-sm text-background-50/90">已收录 18,562+ 优质资源</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-4">
          海量资源，一搜即达
        </h1>
        <p className="text-base md:text-lg text-background-50/80 mb-10 max-w-2xl mx-auto leading-relaxed">
          狠狠撸为您提供<strong>极速检索</strong>、<strong>精准匹配</strong>、<strong>分类浏览</strong>的一站式资源搜索体验，让每一次查找都高效愉悦
        </p>

        <form onSubmit={handleSearch} className="flex flex-col sm:flex-row items-center gap-3 max-w-xl mx-auto">
          <div className="relative flex-1 w-full">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="输入关键词，极速搜索你要的资源..."
              className="w-full pl-11 pr-4 py-3.5 bg-background-50 rounded-xl text-foreground-900 placeholder:text-foreground-400 text-sm outline-none focus:ring-2 focus:ring-primary-400 transition-all"
            />
          </div>
          <button
            type="submit"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-xl text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            狠狠搜索
          </button>
        </form>

        <div className="flex items-center justify-center gap-3 mt-8 flex-wrap">
          <span className="text-xs text-background-50/60">热门搜索：</span>
          {['学习资源', '电影推荐', '设计素材', '软件工具', '音乐专辑'].map((tag) => (
            <button
              key={tag}
              onClick={() => {
                setQuery(tag);
              }}
              className="px-3 py-1 text-xs text-background-50/80 bg-background-50/10 hover:bg-background-50/20 rounded-full transition-colors whitespace-nowrap"
            >
              {tag}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}